import React from 'react';
import { FormGroup, Label, Input, Card, CardHeader, CardBody, Row, Col } from 'reactstrap';

export const HubspotLinksCard = (props: any): JSX.Element => {
  const { handleChange, isSubmitting, hubspot } = props;

  return (
    <Card className="mb-3">
      <CardHeader tag="h5">Hubspot Forms</CardHeader>
      <CardBody>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <div className="mb-3">
                <Label for="hubspot.clickToCancelUrl" className="font-weight-bold">
                  Click to Cancel
                </Label>

                <Input
                  disabled={isSubmitting}
                  id="hubspot.clickToCancelUrl"
                  name="hubspot.clickToCancelUrl"
                  type="text"
                  onChange={handleChange}
                  value={hubspot?.clickToCancelUrl}
                />
              </div>
              <div>
                <Label for="hubspot.homeTransferRequestUrl" className="font-weight-bold">
                  Home Transfer Request
                </Label>

                <Input
                  disabled={isSubmitting}
                  id="hubspot.homeTransferRequestUrl"
                  name="hubspot.homeTransferRequestUrl"
                  type="text"
                  onChange={handleChange}
                  value={hubspot?.homeTransferRequestUrl}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
